import { HeadObject } from 'services/generic';

type Props = { metadata: HeadObject | null };

export const CustomMetaData = ({ metadata }: Props) => {
	if (!metadata) return null;

	const md: HeadObject = metadata;

	const advertScript = md.advertScript || '';
	const schemaScript = md.schemaScript || '';

	return (
		<>
			{advertScript && (
				<div
					dangerouslySetInnerHTML={{ __html: advertScript }}
					style={{ display: 'contents' }}
				/>
			)}
			{schemaScript && (
				<div
					dangerouslySetInnerHTML={{ __html: schemaScript }}
					style={{ display: 'contents' }}
				/>
			)}
		</>
	);
};

export default CustomMetaData;
